import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.fill.js";
// Copyright 2018-2022 @polkadot/ui-shared authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2018 Paritytech via paritytech/oo7/polkadot-identicon
// This has been converted from the original version that can be found at
//
// https://github.com/paritytech/oo7/blob/251ba2b7c45503b68eab4320c270b5afa9bccb60/packages/polkadot-identicon/src/index.jsx
import { blake2AsU8a, decodeAddress } from '@polkadot/util-crypto';

var blake2 = function blake2(value) {
  return blake2AsU8a(value, 512);
};

var S = 64;
var C = S / 2;
var Z = S / 64 * 5;
/* eslint-disable sort-keys */

var SCHEMA = {
  target: {
    colors: [0, 28, 0, 0, 28, 0, 0, 28, 0, 0, 28, 0, 0, 28, 0, 0, 28, 0, 1],
    freq: 1
  },
  cube: {
    colors: [0, 1, 3, 2, 4, 3, 0, 1, 3, 2, 4, 3, 0, 1, 3, 2, 4, 3, 5],
    freq: 20
  },
  quazar: {
    colors: [1, 2, 3, 1, 2, 4, 5, 5, 4, 1, 2, 3, 1, 2, 4, 5, 5, 4, 0],
    freq: 16
  },
  flower: {
    colors: [0, 1, 2, 0, 1, 2, 0, 1, 2, 0, 1, 2, 0, 1, 2, 0, 1, 2, 3],
    freq: 32
  },
  cyclic: {
    colors: [0, 1, 2, 3, 4, 5, 0, 1, 2, 3, 4, 5, 0, 1, 2, 3, 4, 5, 6],
    freq: 32
  },
  vmirror: {
    colors: [0, 1, 2, 3, 4, 5, 3, 4, 2, 0, 1, 6, 7, 8, 9, 7, 8, 6, 10],
    freq: 128
  },
  hmirror: {
    colors: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 8, 6, 7, 5, 3, 4, 2, 11],
    freq: 128
  }
};
/* eslint-enable sort-keys */

var OUTER_CIRCLE = {
  cx: C,
  cy: C,
  fill: '#eee',
  r: C
};
var zeroHash = new Uint8Array();

function getRotation(isSixPoint) {
  var r = isSixPoint ? C / 8 * 5 : C / 4 * 3;
  var rroot3o2 = r * Math.sqrt(3) / 2;
  var ro2 = r / 2;
  var rroot3o4 = r * Math.sqrt(3) / 4;
  var ro4 = r / 4;
  var r3o4 = r * 3 / 4;
  return {
    r: r,
    r3o4: r3o4,
    ro2: ro2,
    ro4: ro4,
    rroot3o2: rroot3o2,
    rroot3o4: rroot3o4
  };
}

function getCircleXY(isSixPoint) {
  var _getRotation = getRotation(isSixPoint),
      r = _getRotation.r,
      r3o4 = _getRotation.r3o4,
      ro2 = _getRotation.ro2,
      ro4 = _getRotation.ro4,
      rroot3o2 = _getRotation.rroot3o2,
      rroot3o4 = _getRotation.rroot3o4;

  return [[C, C - r], [C, C - ro2], [C - rroot3o4, C - r3o4], [C - rroot3o2, C - ro2], [C - rroot3o4, C - ro4], [C - rroot3o2, C], [C - rroot3o2, C + ro2], [C - rroot3o4, C + ro4], [C - rroot3o4, C + r3o4], [C, C + r], [C, C + ro2], [C + rroot3o4, C + r3o4], [C + rroot3o2, C + ro2], [C + rroot3o4, C + ro4], [C + rroot3o2, C], [C + rroot3o2, C - ro2], [C + rroot3o4, C - ro4], [C + rroot3o4, C - r3o4], [C, C]];
}

function findScheme(d) {
  var cum = 0;
  var schema = Object.values(SCHEMA).find(function (schema) {
    cum += schema.freq;
    return d < cum;
  });

  if (!schema) {
    throw new Error('Unable to find schema');
  }

  return schema;
}

function addressToId(address) {
  if (!zeroHash.length) {
    zeroHash = blake2(new Uint8Array(32));
  }

  return blake2(decodeAddress(address)).map(function (x, i) {
    return (x + 256 - zeroHash[i]) % 256;
  });
}

function getColors(address) {
  var total = Object.values(SCHEMA).map(function (s) {
    return s.freq;
  }).reduce(function (a, b) {
    return a + b;
  });
  var id = addressToId(address);
  var d = Math.floor((id[30] + id[31] * 256) % total);
  var rot = id[28] % 6 * 3;
  var sat = Math.floor(id[29] * 70 / 256 + 26) % 80 + 30;
  var scheme = findScheme(d);
  var palette = Array.from(id).map(function (x, i) {
    var b = (x + i % 28 * 58) % 256;

    if (b === 0) {
      return '#444';
    } else if (b === 255) {
      return 'transparent';
    }

    var h = Math.floor(b % 64 * 360 / 64);
    var l = [53, 15, 35, 75][Math.floor(b / 64)];
    return "hsl(".concat(h, ", ").concat(sat, "%, ").concat(l, "%)");
  });
  return scheme.colors.map(function (_, i) {
    return palette[scheme.colors[i < 18 ? (i + rot) % 18 : 18]];
  });
}
/**
 * @description Generate a array of the circles that make up an identicon
 */


export function polkadotIcon(address, _ref) {
  var isAlternative = _ref.isAlternative;
  var xy = getCircleXY(isAlternative);
  var colors;

  try {
    // in some cases, e.g. RN where crypto may not be initialized, chaos can
    // happen when hashing, in these cases we just fill with a placeholder
    colors = getColors(address);
  } catch (_unused) {
    colors = new Array(xy.length).fill('#ddd');
  }

  return [OUTER_CIRCLE].concat(xy.map(function (_ref2, index) {
    var _ref3 = _slicedToArray(_ref2, 2),
        cx = _ref3[0],
        cy = _ref3[1];

    return {
      cx: cx,
      cy: cy,
      fill: colors[index],
      r: Z
    };
  }));
}